import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const HomePage = () => {
  const { user } = useAuth();
  return (
    <div>
      <h1>Welcome</h1>
      <p>This is a public page.</p>
      {user ? (
        <p>Logged in as {user.name}</p>
      ) : (
        <p>You are not logged in.</p>
      )}
    </div>
  );
};

export default HomePage;

